import Modules from '@app/modules';
Modules.register({
    namespace: 'RF/Locator',
    blocks: {
        locator: function () { return import(/* webpackChunkName: "Blocks-Locator" */ '@app/modules/RF/Locator/Blocks/locator.vue'); }
    }
});
